module.exports = __webpack_public_path__ + "media/assets/icons/arrow-next-be6e00736c3e4363246334fa66215267.svg";